import RestApiModel from "@/api/Model/RestApiModel";

class InsurerRole extends RestApiModel {
  static getResourceEndpoint() {
    return '/facility-insurer-roles';
  }
}

export default InsurerRole;
